// removed by extract-text-webpack-plugin
module.exports = {"listDataBank":"_2Sx83UYrixUyjzxHvYyRR-","alertMessage":"_1UzbtsH6cGSTEcppBBOccQ"};


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/Profile/Pages/ConfigFinance/style.css
// module id = 445
// module chunks = 38